<button type="button" class="btn btn-success"
        popover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus."
        popoverTitle="Dismissible popover"
        triggers="focus">
  Dismissible popover
</button>

